import { useState } from 'react'
import { Box, SxProps, Theme } from '@mui/material'

import PlainTooltip from '../m3/plain-tooltip'

interface IProps {
  label: string
  testId: string
  sx: SxProps<Theme>
}

const StatusDot = ({ label, testId, sx }: IProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false)

  return (
    <PlainTooltip title={label} open={isTooltipOpen} onClose={() => setIsTooltipOpen(false)}>
      <Box
        component="span"
        data-testid={testId}
        aria-label={label}
        onMouseEnter={() => setIsTooltipOpen(true)}
        onMouseLeave={() => setIsTooltipOpen(false)}
        sx={sx}
      />
    </PlainTooltip>
  )
}

export default StatusDot
